/**
 * @generated SignedSource<<96f87ce8d35699f2b95a8aa8bba8c7d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useDefaultCustomerTypeId_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club: {
        readonly defaultCustomerType: {
          readonly id: string;
        } | null | undefined;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useDefaultCustomerTypeId_session";
};
export type useDefaultCustomerTypeId_session$key = {
  readonly " $data"?: useDefaultCustomerTypeId_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDefaultCustomerTypeId_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useDefaultCustomerTypeId_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomerType",
                  "kind": "LinkedField",
                  "name": "defaultCustomerType",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "d0a642dbe7873605145abd97e2319311";

export default node;
